import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { AdminService } from 'src/app/services/admin.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false,
})
export class ResetPasswordComponent implements OnInit {
  public resetPass: boolean = false;
  public submitted: boolean = false;
  public resetPasswordForm!: FormGroup;
  private email!: string;
  private token!: string;
  private key!: string;

  constructor(
    private _fb: FormBuilder,
    private adminService: AdminService,
    private _route: ActivatedRoute,
    private _toastr: ToastrService,
    private sharedService: SharedService,
    private confirmationService: ConfirmationService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this._route.queryParams.subscribe(params => {
      this.email = params['email'];
      this.token = params['token'];
      this.key = params['key'];
    });
    this.createForm();
  }

  // createForm() {
  //   this.resetPasswordForm = this._fb.group({
  //     password: [
  //       '',
  //       [
  //         Validators.required,
  //         Validators.maxLength(30),
  //         Validators.minLength(0),
  //       ],
  //     ],
  //     confirmPassword: [
  //       '',
  //       [Validators.required, this.matchOtherValidator('password')],
  //     ],
  //   });
  // }

  createForm() {
    this.resetPasswordForm = this._fb.group(
      {
        password: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(8)]],
        confirmPassword: ['', [Validators.required]],
      },
      { validator: this.passwordMatchValidator }
    );
  }

  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }

  // generatePass(event: any) {
  //   const password = this.sharedService.generatePass();
  //   this.confirmationService.confirm({
  //     target: event.target,
  //     message: `${password}`,
  //     icon: 'pi pi-key',
  //     acceptLabel: 'Use',
  //     rejectLabel: 'Cancel',
  //     acceptIcon: 'pi pi-thumbs-up',
  //     accept: () => {
  //       this.resetPasswordForm.patchValue({
  //         password,
  //         confirmPassword: password,
  //       });
  //     },
  //     reject: () => { },
  //   });
  // }

  generatePass(event: any) {
    const password = this.sharedService.generatePass();
    this.confirmationService.confirm({
      target: event.target,
      message: `${password}`,
      icon: 'pi pi-key',
      acceptLabel: 'Use',
      rejectLabel: 'Cancel',
      acceptIcon: 'pi pi-thumbs-up',
      accept: () => {
        this.resetPasswordForm.patchValue({
          password,
          confirmPassword: password,
        });
        this.resetPasswordForm.get('password')?.markAsDirty();
        this.resetPasswordForm.get('confirmPassword')?.markAsDirty();
      },
      reject: () => {},
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.resetPasswordForm.valid) {
      this.adminService
        .resetNewPassword(this.email, this.token, this.resetPasswordForm.value.confirmPassword)
        .subscribe({
          next: res => {
            this.resetPass = true;
            this._toastr.success(res.message);
          },
          error: err => this._toastr.error(err.error.message),
        });
    }
  }

  matchOtherValidator(otherControlName: string) {
    let thisControl: FormControl;
    let otherControl: FormControl;
    return function matchOtherValidate(control: FormControl) {
      if (!control.parent) {
        return null;
      }
      if (!thisControl) {
        thisControl = control;
        otherControl = control.parent.get(otherControlName) as FormControl;
        if (!otherControl) {
          throw new Error('matchOtherValidator(): other control is not found in parent group');
        }
        otherControl.valueChanges.subscribe(() => {
          thisControl.updateValueAndValidity();
        });
      }
      if (!otherControl) {
        return null;
      }
      if (otherControl.value !== thisControl.value) {
        return {
          matchOther: true,
        };
      }
      return null;
    };
  }

  gotoLogin() {
    if (this.key === 'client') {
      this._router.navigate(['/client-login']);
      return;
    }
    this._router.navigate(['/']);
  }
}
